<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft">
    <div :class="$style.dropdown">
      <a-avatar :src="userInfo.photoURL" size="large" :class="$style.avatar"/>
    </div>
    <a-menu slot="overlay">
      <a-menu-item>
        <div>
          <strong>Hello, {{ userInfo.displayName | getShortName }}</strong>
        </div>
        <!-- <div>
          <strong class="mr-1">Billing Plan:</strong> Professional
        </div>
        <div>
          <strong class="mr-1">Role:</strong> Admin
        </div> -->
      </a-menu-item>
      <a-menu-divider/>
      <a-menu-item>
        <router-link to="/profile">
          <i :class="$style.menuIcon" class="icmn-user"></i> {{ $t('profile.title') }}
        </router-link>
      </a-menu-item>
      <a-menu-item>
        <a href="javascript: void(0);" @click="$auth.logout">
          <i :class="$style.menuIcon" class="icmn-exit"></i> {{ $t('profile.logout') }}
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import user from '@/mixins/user'
export default {
  data: function () {
    return {
    }
  },
  methods: {
  },
  filters: {
    getShortName(str) {
      if ( !str ) return ""
      return str.split(" ").pop()
    }
  },
  mixins: [user],
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
